import toastr from 'toastr';
import { locale, format } from 'svelte-i18n';
import { get as getStore } from 'svelte/store';


function setLocale() {
    let setLocale = getStore(locale);
    if (setLocale != "es" && setLocale != "en") setLocale = 'es';
    locale.set(setLocale);
}


export let Toast = () => {
    setLocale();
    return toastr["error"](getStore(format)("notifications.try_later"), "Error")
};

export let ToastNetworkError = () => {
    setLocale();
    return toastr["error"](getStore(format)("notifications.network_error"), getStore(format)("notifications.fatal_error"))
};

export let ToastSessionExpired = () => {
    setLocale();
    return toastr["error"](getStore(format)("notifications.credentials_again"), getStore(format)("notifications.expired_session"))
};

export let ToastLimitReached = () => {
    setLocale();
    return toastr["info"](getStore(format)("notifications.limit_reached"))
};

export let ToastThirdPartyNotification = () => {
    setLocale();
    return toastr["info"](getStore(format)("notifications.third_party_notification"))
};

export let Toast401 = () => {
    setLocale();
    return toastr["error"](getStore(format)("notifications.login"))
};

export let Toast403 = () => {
    setLocale();
    return toastr["error"](getStore(format)("notifications.not_allowed"))
};

export let Toast404 = () => {
    setLocale();
    return toastr["error"](getStore(format)("notifications.resource_not_found"))
};

export let Toast422 = () => {
    setLocale();
    return toastr["error"](getStore(format)("notifications.verify_form_data"))
};

export let Toast429 = () => {
    setLocale();
    return toastr["error"](getStore(format)("notifications.too_many_requests_429"))
};

export let ToastPasswordError = () => {
    setLocale();
    return toastr["error"](getStore(format)("notifications.verify_password"))
};

export let ToastdeleteOwnUserError = () => {
    setLocale();
    return toastr["error"](getStore(format)("notifications.delete_own_user"))
};

export let ToastRegisterEmailExists = () => {
    setLocale();
    return toastr["error"](getStore(format)("notifications.email_exists"))
};

export let ToastUpdateVDBOk = () => {
    setLocale();
    return toastr["success"](getStore(format)("notifications.update_success"))
};

export let ToastUploadVRFOk = () => {
    setLocale();
    return toastr["success"](getStore(format)("notifications.vrf_success"))
};

export let ToastSaveOk = (config) => {
    setLocale();
    toastr.options = config.options;
    toastr["success"](config.data + (config.is_massive ? getStore(format)("notifications.saved_plural") : getStore(format)("notifications.saved")) + getStore(format)("notifications.with_success"));
}

export let ToastRequestSuccess = () => {
    setLocale();
    return toastr["success"](getStore(format)("notifications.request_success"))
};

export let ToastCopiedOk = () => {
    setLocale();
    return toastr["success"](getStore(format)("copied_to_clipboard"))
};

export let awsUpdateSuccess = () => {
    setLocale();
    return toastr["success"](getStore(format)("notifications.aws_sync_ok"))
};

export let ToastSaveError = (config) => {
    setLocale();

    toastr.options = config.options;

    if (!config.data) config.data = "";
    config.data = !config.data.includes(getStore(format)("finding.word")) ? getStore(format)("notifications.element") + config.data : config.data;

    if (config.error && config.error.detail == 'The object already exists') {
        toastr["error"](getStore(format)("notifications.the_element") + config.data + " " + getStore(format)("notifications.alredy_exists"), "Error")
    }
    else {
        toastr["error"](getStore(format)("notifications.could_not_save_the") + config.data, "Error");
    }
}

export let ToastThirdParty = (config) => {
    setLocale();
    toastr.options = config.options;
    if (!config.data) config.data = "";
    toastr["warning"](getStore(format)("notifications.asset_cant_be_in_scope") + config.data + " " + getStore(format)("notifications.belongs_to_third"), "");
}


export let ToastDeleteOk = (config) => {
    setLocale();
    toastr.options = config.options;
    toastr["success"](config.data + (config.is_massive ? getStore(format)("deleted_plural") : getStore(format)("deleted")) + getStore(format)("notifications.with_success"));
}

export let ToastDeleteError = (config) => {
    setLocale();
    toastr.options = config.options;
    if (!config.is_massive) {
        toastr["error"](getStore(format)("notifications.element_not_deleted") + config.data);
    }
    else {
        toastr["error"](getStore(format)("notifications.elements_not_deleted"));
    }
}

export let AutoDeleteExcluded = (config) => {
    setLocale();
    toastr.options = config.options;
    toastr["error"](getStore(format)("notifications.autodelete_excluded", { values: { name: config.data } }));
}

export let ToastEmailRecentlyUsed = (config) => {
    setLocale();
    toastr.options = config.options;
    toastr["error"](getStore(format)("notifications.email_has_requests"));
}

export let ToastIPrecentlyUsed = (config) => {
    setLocale();
    toastr.options = config.options;
    toastr["error"](getStore(format)("notifications.too_many_requests"));
}

export let ToastCvssVectorError = (config) => {
    setLocale();
    toastr.options = config.options;
    toastr["error"](getStore(format)("notifications.verify_cvss") + '<br />' + getStore(format)("notifications.id_text") + config.id + '<br />' + getStore(format)("notifications.title_text") + config.data);
}

export let ToastCweInvalid = (config) => {
    setLocale();
    toastr.options = config.options;
    toastr["error"](getStore(format)("notifications.cwe_not_found") + '<br />' + getStore(format)("notifications.id_text") + config.id + '<br />' + getStore(format)("notifications.title_text") + config.data);
}

export let ModalConfirmScopeRemoval = (config) => {
    setLocale();
    let text = ''
    if (config.asset == 'ip') {
        let warning_text = " <br /><small style='font-size: 14px;'>" + getStore(format)("notifications.delete_services") + "</small>"
        text = (config.massive ? getStore(format)("notifications.selected_ips") : getStore(format)("notifications.the_ip")) + warning_text
    }
    if (config.asset == 'web') {
        let warning_text = "  <br /><small style='font-size: 14px;'>" + getStore(format)("notifications.will_delete_vuls") + "</small>"
        text = (config.massive ? getStore(format)("notifications.selected_webs") : getStore(format)("notifications.this_web")) + warning_text
    }

    else {
        text = (config.massive ? getStore(format)("notifications.selected_assets") : getStore(format)("notifications.this_asset"));
    }

    return Swal.mixin({
        position: 'center',
        titleText: getStore(format)("notifications.remove_from_scope"),
        html: getStore(format)("notifications.wish_remove_scope") + text,
        confirmButtonText: getStore(format)("notifications.yes"),
        showCancelButton: true,
        cancelButtonText: getStore(format)("notifications.no"),
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalConfirmScopeAddition = () => {
    setLocale();
    return Swal.mixin({
        position: 'center',
        titleText: getStore(format)("notifications.add_to_scope"),
        text: getStore(format)("notifications.add_asset_to_scope"),
        confirmButtonText: getStore(format)("notifications.yes"),
        showCancelButton: true,
        cancelButtonText: getStore(format)("notifications.no"),
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}


export let ModalConfirmMassiveScopeAddition = () => {
    setLocale();
    return Swal.mixin({
        position: 'center',
        titleText: getStore(format)("notifications.add_to_scope"),
        text: getStore(format)("notifications.add_assets_to_scope"),
        confirmButtonText: getStore(format)("notifications.yes"),
        showCancelButton: true,
        cancelButtonText: getStore(format)("notifications.no"),
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalConfirmDelete = (config = {}) => {
    setLocale();

    let text = (config.massive ? getStore(format)("notifications.selected_elements") : getStore(format)("notifications.the_element_question")) + (config.findings_warning ? ' <br /><small style="font-size: 14px;">' + getStore(format)("notifications.will_delete_findings") + '</small>' : '');

    return Swal.mixin({
        position: 'center',
        titleText: getStore(format)("notifications.delete"),
        html: getStore(format)("notifications.wish_delete") + text,
        confirmButtonText: getStore(format)("notifications.yes"),
        showCancelButton: true,
        cancelButtonText: getStore(format)("notifications.no"),
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalSelectAll = (config = {}) => {
    setLocale();

    let text = getStore(format)("notifications.select_all");

    return Swal.mixin({
        position: 'center',
        titleText: getStore(format)("notifications.select_all_title"),
        html: text,
        confirmButtonText: getStore(format)("notifications.select_all_elements"),
        showCancelButton: true,
        cancelButtonText: getStore(format)("notifications.select_page"),
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalDeselectAll = (config = {}) => {
    setLocale();

    return Swal.mixin({
        position: 'center',
        titleText: getStore(format)("notifications.deselect_all_title") || "Deselect Elements",
        html: getStore(format)("notifications.deselect_all_text") || "Do you want to deselect these elements?",
        confirmButtonText: getStore(format)("notifications.deselect_all_elements") || "Deselect All",
        showCancelButton: true,
        cancelButtonText: getStore(format)("notifications.deselect_page") || "Deselect Page",
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalConfirmAddNetworkFromIP = (config = {}) => {
    setLocale();
    let text = (getStore(format)("notifications.ip_belongs_to_net") + config.network);

    return Swal.mixin({
        position: 'center',
        titleText: getStore(format)("notifications.wish_add_net"),
        html: text + '<br />' + getStore(format)("notifications.wish_add_net") + config.network + "/" + config.subnet + '?',
        confirmButtonText: getStore(format)("notifications.yes"),
        showCancelButton: true,
        cancelButtonText: getStore(format)("notifications.no"),
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalConfirmCloseSecret = (config) => {
    setLocale();
    let text = (getStore(format)("notifications.secret_no_file_downloaded") + ' ' + (!config.fileType || config.fileType == 'docker' ? getStore(format)("notifications.secret_not_copied") : '') + ' ' + getStore(format)("notifications.secret_warning"));

    return Swal.mixin({
        position: 'center',
        titleText: getStore(format)("notifications.add_integration"),
        html: text,
        confirmButtonText: getStore(format)("notifications.yes"),
        showCancelButton: true,
        cancelButtonText: getStore(format)("notifications.no"),
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalConfirmScanner = (config) => {
    setLocale();
    let text = (getStore(format)("notifications.scanner_new") + (config.fileType == "docker" ? getStore(format)("notifications.scanner_new_2") : getStore(format)("notifications.scanner_new_3")) + '<br /><br />' + getStore(format)("notifications.scanner_continue"));

    return Swal.mixin({
        position: 'center',
        titleText: getStore(format)("notifications.scanner_integration"),
        html: text,
        confirmButtonText: getStore(format)("notifications.yes"),
        showCancelButton: true,
        cancelButtonText: getStore(format)("notifications.no"),
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalConfirmAddNetworksFromIPs = (config = {}) => {
    setLocale();
    let text = ('Vulseek detectó que algunas direcciones IP que intentó cargar pertenecen a las redes ' + "<br />" + config.networks);

    return Swal.mixin({
        position: 'center',
        titleText: 'Agregar Red',
        html: text + '<br />' + '¿Desea agregarlas?',
        confirmButtonText: 'Sí',
        showCancelButton: true,
        cancelButtonText: 'No',
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalConfirmSnapshot = (config) => {
    setLocale();
    return Swal.mixin({
        position: 'center',
        titleText: getStore(format)("notifications.confirm_snapshot"),
        html: getStore(format)("notifications.wish_new_snapshot"),
        confirmButtonText: getStore(format)("notifications.yes"),
        showCancelButton: true,
        cancelButtonText: getStore(format)("notifications.no"),
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}


export let ModalWelcome = () => {
    setLocale();
    return Swal.mixin({
        position: 'center',
        titleText: '¡Le damos la bienvenida a Vulseek!',
        input: 'checkbox',
        inputPlaceholder: 'No volver a mostrar este mensaje',
        html: '<div class="welcome-background" style="text-align: left; font-size: 1rem;">' + 'Para que Vulseek empiece a identificar hallazgos en sus activos es necesario que cargue los mismos.' + '<br /><br />' + 'Primer paso: Cargue el/los dominio/s asociado/s a su organización, Vulseek comenzará con el reconocimiento e irá hallando problemáticas de seguridad. Haga click para dar de alta su primer <a onclick="swal.closeModal();" style="text-decoration: underline; z-index: 3; position: relative;" href="/domain">dominio</a> ' + '<br /><br />' + 'Esperamos ayudarle a identificar los inconvenientes de seguridad de su infraestructura expuesta a Internet.' + '<br /><br />' + 'Ante cualquier inquietud puede contactarnos en vulseek@securetia.com.' + '<br /><br />' + 'Equipo de Vulseek' + '</div>',
        confirmButtonText: 'Comenzar',
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}
export let ModalAssetsHelper = () => {
    setLocale();
    return Swal.mixin({
        position: 'center',
        titleText: getStore(format)("components.helpers.asset.title"),
        html: '<div style="text-align: left; font-size: 1rem;">' + getStore(format)("components.helpers.asset.upload") + `<a style="text-decoration: underline;" href="/asset/domain" onclick="swal.closeModal();">${getStore(format)("asset.kind.domain.plural")}</a> ` + getStore(format)("and") + `<a href="/asset/public_network" style="text-decoration: underline;" onclick="swal.closeModal();">${getStore(format)("asset.kind.public_network.plural")}</a>` + getStore(format)("components.helpers.asset.host_ip_discovery") + '<br /><br />' + getStore(format)("components.helpers.asset.manual_upload") + '<button style="background-color: #f8f9fa;border-color: #ddd;color: #444;" class="btn btn-secondary btn-add btn-xs t-add-ip-btn" tabindex="0" aria-controls="ipTable" type="button"><i class="fas fa-plus"></i></button>.' + '<br /><br />' + getStore(format)("components.helpers.asset.contact") + ' vulseek@securetia.com' + '<br /><br />' + getStore(format)("components.helpers.asset.bye") + '<br /><br />' + getStore(format)("components.helpers.asset.team") + '</div>',
        confirmButtonText: 'Ok',
        input: 'checkbox',
        inputPlaceholder: getStore(format)("components.helpers.not_show_again"),
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalUsersHelper = () => {
    setLocale();
    return Swal.mixin({
        position: 'center',
        titleText: getStore(format)("components.helpers.user.title"),
        input: 'checkbox',
        inputPlaceholder: getStore(format)("components.helpers.not_show_again"),
        html: '<div style="text-align: left; font-size: 1rem;">' + getStore(format)("components.helpers.user.text") + '<br /><br />' + `<ul><li><strong>${getStore(format)("page.user.roles.viewer")}</strong>: ${getStore(format)("components.helpers.user.viewer")}</li>` + `<li><strong>${getStore(format)("page.user.roles.operator")}</strong>: ${getStore(format)("components.helpers.user.operator")}</li>` + `<li><strong>${getStore(format)("page.user.roles.administrator")}</strong>: ${getStore(format)("components.helpers.user.admin")}</li></ul>` + getStore(format)("components.helpers.asset.contact") + ' vulseek@securetia.com' + '<br /><br />' + getStore(format)("components.helpers.asset.team") + '</div>',
        confirmButtonText: 'Ok',
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalSelectElement = () => {
    setLocale();
    return Swal.mixin({
        position: 'center',
        titleText: ' ',
        text: 'Por favor, seleccione un elemento de la tabla.',
        confirmButtonText: 'Cerrar',
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalSelectOnlyOne = () => {
    setLocale();
    return Swal.mixin({
        position: 'center',
        titleText: ' ',
        text: 'Por favor, seleccione un sólo elemento de la tabla.',
        confirmButtonText: 'Cerrar',
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalConfirmPlanUpgrade = (config = {}) => {
    setLocale();

    let text = getStore(format)("notifications.upgrade_plan");

    return Swal.mixin({
        position: 'center',
        titleText: "Plan",
        html: text,
        confirmButtonText: getStore(format)("notifications.yes"),
        showCancelButton: true,
        cancelButtonText: getStore(format)("notifications.no"),
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ModalConfirmPentest = (config = {}) => {
    setLocale();

    let text = getStore(format)("notifications.pentest_confirm");

    return Swal.mixin({
        position: 'center',
        titleText: "Penetration Test",
        html: text,
        confirmButtonText: getStore(format)("notifications.yes"),
        showCancelButton: true,
        cancelButtonText: getStore(format)("notifications.no"),
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}


export let ModalConfirmPhishing = (config = {}) => {
    setLocale();

    let text = getStore(format)("notifications.phishing_confirm");

    return Swal.mixin({
        position: 'center',
        titleText: getStore(format)("buttons.phishing_solicit"),
        html: text,
        confirmButtonText: getStore(format)("notifications.yes"),
        showCancelButton: true,
        cancelButtonText: getStore(format)("notifications.no"),
        customClass: {
            confirmButton: 'btn btn-md ps-4 pe-4  me-1 btn-primary',
            cancelButton: 'btn btn-md ps-4 pe-4 btn-default',
        },
        buttonsStyling: false,
    });
}

export let ToastInvalidCAPTCHA = (config) => {
    setLocale();
    toastr.options = config.options;
    toastr["error"](getStore(format)("altcha.invalid"));
}


export let ToastDomainNotFound = (config) => {
    setLocale();

    toastr.options = config.options;

    if (!config.data) config.data = "";

    toastr["error"](getStore(format)("notifications.could_not_save_the") + getStore(format)("notifications.element")  + config.data + " " + getStore(format)("page.asset.form.errors.domain_not_found"), "Error")

}

export let notificate = (errorType = 'default', type, config = {}) => {
    setLocale();
    const errors = {
        'default': () => Toast(),
        'network_error': () => ToastNetworkError(),
        '401': () => Toast401(),
        '403': () => Toast403(),
        '404': () => Toast404(),
        '422': () => Toast422(),
        '429': () => Toast429(),
        '500': () => ToastNetworkError(),
        'save_ok': () => ToastSaveOk(config),
        'request_ok': () => ToastRequestSuccess(config),
        'copied': () => ToastCopiedOk(config),
        'save_error': () => ToastSaveError(config),
        'third_party': () => ToastThirdParty(config),
        'delete_ok': () => ToastDeleteOk(config),
        'delete_error': () => ToastDeleteError(config),
        'limitReached': () => ToastLimitReached(),
        'password_error': () => ToastPasswordError(),
        'delete_own_user_error': () => ToastdeleteOwnUserError(),
        'register_email_exists': () => ToastRegisterEmailExists(),
        'updateVDBOk': () => ToastUpdateVDBOk(),
        'uploadVRFOk': () => ToastUploadVRFOk(),
        'email_recently_used': () => ToastEmailRecentlyUsed(config),
        'ip_address_recently_used': () => ToastIPrecentlyUsed(config),
        'cvss_vector_error': () => ToastCvssVectorError(config),
        'cwe_invalid': () => ToastCweInvalid(config),
        'session_expired': () => ToastSessionExpired(),
        'confirm_delete': (config) => ModalConfirmDelete(config),
        'select_all': (config) => ModalSelectAll(config),
        'deselect_all': (config) => ModalDeselectAll(config),
        'confirm_network_from_ip': (config) => ModalConfirmAddNetworkFromIP(config),
        'confirm_networks_from_ips': (config) => ModalConfirmAddNetworksFromIPs(config),
        'confirm_scope_removal': (config) => ModalConfirmScopeRemoval(config),
        'confirm_secret_closure': (config) => ModalConfirmCloseSecret(config),
        'confirm_scanner': (config) => ModalConfirmScanner(config),
        'confirm_scope_addition': (config) => ModalConfirmScopeAddition(config),
        'confirm_scope_massive_addition': (config) => ModalConfirmMassiveScopeAddition(config),
        'modal_welcome': (config) => ModalWelcome(config),
        'modal_assets_helper': (config) => ModalAssetsHelper(config),
        'modal_users_helper': (config) => ModalUsersHelper(config),
        'select_element': (config) => ModalSelectElement(config),
        'select_only_one': (config) => ModalSelectOnlyOne(config),
        'confirm_plan_upgrade': (config) => ModalConfirmPlanUpgrade(config),
        'confirm_pentest': (config) => ModalConfirmPentest(config),
        'confirm_phishing': (config) => ModalConfirmPhishing(config),
        "aws_sync_ok": (config) => awsUpdateSuccess(config),
        "autodelete_excluded": () => AutoDeleteExcluded(config),
        'third_party_notification': () => ToastThirdPartyNotification(config),
        "confirm_new_snapshot": () => ModalConfirmSnapshot(config),
        'invalid_captcha': () => ToastInvalidCAPTCHA(config),
        'domain_not_found': () => ToastDomainNotFound(config),
    }
    if (type == "modal") {
        if (!errors[errorType]) return Toast();
        return errors[errorType](config).fire();
    }
    else {
        if (config && !config.options) {
            config.options = {
                "timeOut": "5000",
                "extendedTimeOut": "1000",
                "showDuration": "300",
                "hideDuration": "1000",
                "closeButton": true
            }
        }
        return errors[errorType]();
    }

}
